export default {
  "head": {
    "title": "腾讯云"
  },
  "微信分享": {
    "标题": "腾讯 Techo 开发者大会",
    "介绍": "腾讯Techo开发者大会是由腾讯云发起的面向全球开发者和技术爱好者的年度盛会，2019年11月在北京首次召开。作为一个专注于前沿技术研讨的非商业大会，Techo大会致力于开发者的能力成长和实践创新，旨在通过汇聚全球顶尖行业专家和技术爱好者，\n搭建一个开放、中立、活跃的技术交流平台，分享热点技术、主流应用、开源生态和产品革新，代码传递思想，技术创造回响。",
    "图片": "https://static.geekbang.org/infoq/5cad99200145e.png?imageView2/0/w/800"
  },
  "导航栏": {
    "list": [
      {
        "name": "头条新闻",
        "link": "#toutiao",
        "是否显示": true
      },
      {
        "name": "大会报道",
        "link": "#xiaoxi",
        "是否显示": true
      },
      {
        "name": "相关资讯",
        "link": "#essays",
        "是否显示": true
      },
      {
        "name": "精彩瞬间",
        "link": "#image",
        "是否显示": true
      },
      {
        "name": "",
        "link": "",
        "是否显示": true
      },
      {
        "name": "",
        "link": "",
        "是否显示": true
      },
      {
        "name": "",
        "link": "",
        "是否显示": true
      }
    ]
  },
  "banner": {
    "link": "https://cloud.tencent.com/act/event/techo-developer",
    "图片（pc）": "https://attachments.tower.im/tower/01f761026bb5e5f49e444712e37c6794",
    "图片（mobile）": "https://attachments.tower.im/tower/6f6ff22ea9039c1324cd2d99da7ab515"
  },
  "头条新闻": {
    "是否显示": true,
    "title": {
      "h1": "头条新闻",
      "h2": ""
    },
    "left": {
      "imgList": [
        "https://constatic.geekbang.org/infoq/5dc9203a0586a.png?imageView2/0/w/800",
        "https://constatic.geekbang.org/infoq/5dc8e1dc078f0.png?imageView2/0/w/800",
        "https://constatic.geekbang.org/infoq/5dc9203990dde.png?imageView2/0/w/800",
        "https://constatic.geekbang.org/infoq/5dc8e22b4a3bc.png?imageView2/0/w/800"
      ]
    },
    "right": {
      "list": [
        {
          "标题": "邱跃鹏：软硬件一体化、Serverless、智能化是云计算三大趋势",
          "介绍": "云计算未来有三大趋势，即软硬件一体化（Cloud Native Hardware）、无服务器计算（Serverless）和智能化（Smart）。",
          "link": "https://www.infoq.cn/article/rlPJZEVkOdoRTUkviBti"
        },
        {
          "标题": "从引进到自研，腾讯大数据平台每日数据计算量超30万亿",
          "介绍": "经过10年的积累，腾讯大数据平台的算力资源池目前已有超过20万台的规模，每天实时数据计算量超过30万亿条，腾讯已经成为中国实时数据计算量最大的公司。并且，随着资源管理平台核心TKE和分布式数据库TBase正式对外开源，腾讯正在成为大数据领域开源最全面的公司。",
          "link": "https://www.infoq.cn/article/DdqZQZOZ4hzKsCa39zdO"
        },
        {
          "标题": "腾讯TECHO开发者大会召开，首次揭秘腾讯基础架构演进历程",
          "介绍": "在微信、QQ等国民级业务不断发展的背后，包括服务器、网络、IDC、计算、存储、数据库等在内的基础设施和技术架构一直在不断进化，目前已经进入“生而为云”的新阶段。",
          "link": "https://www.infoq.cn/article/zLuLm0SHC1FiDGHphVuX"
        },
        {
          "标题": "腾讯杰出科学家刘杉：5G时代，人工智能技术将成媒体融合的推进器",
          "介绍": "腾讯杰出科学家、多媒体实验室总经理刘杉发表了主题为“视频编解码技术的演进和应用”的演讲，从在线视频驱动互联网流量爆发的技术支撑与技术现状，当前主流视频编解码格式和标准的制定，视频编解码技术的演进和应用，以及5G时代下多媒体业务的发展方向等方面，分享了腾讯多媒体实验室的最新成果与思考。",
          "link": "https://www.infoq.cn/article/hKDuoVLGgMvDVi4aJNlQ"
        },
        {
          "标题": "",
          "介绍": "",
          "link": ""
        },
        {
          "标题": "",
          "介绍": "",
          "link": ""
        },
        {
          "标题": "",
          "介绍": "",
          "link": ""
        }
      ],
      "more": "查看全文>>"
    }
  },
  "大会报到": {
    "是否显示": true,
    "title": {
      "h1": "大会报道",
      "h2": ""
    },
    "more": "查看更多>>",
    "link": "",
    "list": [
      {
        "title": "聚焦技术和实践，腾讯全面揭秘基础设施和大数据演进之路",
        "description": "",
        "link": "https://www.infoq.cn/article/ubkRaJxdLwivypN37WJ1",
        "图片": "https://constatic.geekbang.org/infoq/5dc8e0f92355d.png?imageView2/0/w/800"
      },
      {
        "title": "从0.1时代到1.0 时代“小程序·云开发”加速构建开发者生态",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dd4e3a586e4c.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/CulLddgua3aarYUdcI2Z",
        "tip": "2019.11.11"
      },
      {
        "title": "腾讯云与 Serverless.com 达成全球战略合作，打造下一代无服务器计算开发平台",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dd4e3a4e1ace.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/CZ4Ljo9hpek6MsTg9J7K",
        "tip": "2019.11.11"
      },
      {
        "title": "四大开源项目联合发布，腾讯已成Github全球贡献前十公司",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dc9203956ed1.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/9Sh8caacFv8pJ0opC9YD",
        "tip": "2019.11.11"
      },
      {
        "title": "腾讯云举办首届数据库诊断赛， MySQL之父亲自颁奖",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dc92039bdb51.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/EmXrAwlhrGyRfKZXaIQT",
        "tip": "2019.11.11"
      },
      {
        "title": "直击智能语音行业痛点，腾讯云小微云函数助力AI语音落地",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dd4d8f50191b.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/zu0ZVWvY17scRuebhvIu",
        "tip": ""
      },
      {
        "title": "智能化与沉浸式将成视觉媒体的未来趋势",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dd4d8f594bdc.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/fT6VXoGwmYrzagspl7G0",
        "tip": ""
      },
      {
        "title": "腾讯安全亮相Techo大会，为上云提供完备加密基础设施能力",
        "description": "",
        "图片": "https://constatic.geekbang.org/infoq/5dd4d8f748b18.png?imageView2/0/w/800",
        "link": "https://www.infoq.cn/article/fTXXQ96PgfuWURgorkwi",
        "tip": ""
      },
      {
        "title": "",
        "description": "",
        "图片": "",
        "link": "",
        "tip": ""
      },
      {
        "title": "",
        "description": "",
        "图片": "",
        "link": "",
        "tip": ""
      }
    ]
  },
  "相关资讯": {
    "是否显示": true,
    "title": {
      "h1": "相关资讯",
      "h2": ""
    },
    "list": [
      {
        "排序": "1",
        "图片": "https://constatic.geekbang.org/infoq/5dc92039c6b6d.png?imageView2/0/w/800",
        "title": "云原生进程再提速，腾讯云发布四款云中间件产品",
        "description": "“以微服务、容器、无服务器以等为代表的云原生技术正在成为下一代云计算发展的重要支撑，腾讯云云原生团队正在从技术、产品、生态等多个层面全面布局，引领整个行业的发展，为用户提供极致的云计算服务。” 腾讯云中间件产品总经理 Yunong Xiao 表示。",
        "link": "https://www.infoq.cn/article/SXPoObQ5CgiqOy2RJlbl",
        "tip": ""
      },
      {
        "排序": "2",
        "图片": "https://constatic.geekbang.org/infoq/5dc9203b79b8d.png?imageView2/0/w/800",
        "title": "腾讯云发布：国内首个云原生5G SD-WAN产品要来了",
        "description": "11月7日，腾讯云在Techo开发者大会上宣布，将在国内首发云原生5G SD-WAN产品，结合腾讯积累多年的大型网络调度技术和边缘接入优化技术，解决企业联网不稳定、成本昂贵等核心问题，助力企业进入智能全互联时代。",
        "link": "https://www.infoq.cn/article/Hg6oe4wBNUtbOwlLGYrx",
        "tip": ""
      },
      {
        "排序": "3",
        "图片": "https://constatic.geekbang.org/infoq/5dc92137b77c3.png?imageView2/0/w/800",
        "title": "三个阶段、两项技术突破，揭秘下一代腾讯云高性能网络技术",
        "description": "大数据时代带来的数据流动性，对承担数据流动的网络技术带来了新挑战。11月7日，在腾讯云主办的首届Techo开发者大会现场，腾讯云对下一代高性能网络技术进行了揭秘。",
        "link": "https://www.infoq.cn/article/89g5ZwKQhvhZ50y4Bdr0",
        "tip": ""
      },
      {
        "排序": "4",
        "图片": "https://constatic.geekbang.org/infoq/5dc92137175a9.png?imageView2/0/w/800",
        "title": "聚焦安全运营效能痛点，腾讯天幕助力企业降本提",
        "description": "2019年11月7日，腾讯Techo开发者大会在京举办，云安全技术与应用分论坛上，来自腾讯安全平台部的安全策略专家聂利权分享了对企业安全运营现状的思考，并介绍了腾讯安全治理平台通过智能威胁研判，助力网络安全运营提效的探索和实践。",
        "link": "https://www.infoq.cn/article/ExpLEhiYy5cBXPOvNiNz",
        "tip": ""
      },
      {
        "排序": "5",
        "图片": "https://constatic.geekbang.org/infoq/5dc9213846ccc.png?imageView2/0/w/800",
        "title": "聚焦技术发展及开源生态 腾讯全面揭秘大数据平台演进之路",
        "description": "11月7日，腾讯Techo开发者大会的“腾讯大数据”分论坛上，围绕大数据的新技术进展及开源生态，腾讯大数据团队进行了详细解读，包括由集群规模化与异构化挑战所引发的漂移计算等新技术创新，越来越普遍的实时计算需求以及新架构的实践，能够无限弹性扩展的、面向未来的数据湖体系结构，大数据技术发展的新趋势与新挑战等。",
        "link": "https://www.infoq.cn/article/Dqw81RmLICJKQBSu6tRH",
        "tip": ""
      },
      {
        "排序": "6",
        "图片": "https://constatic.geekbang.org/infoq/5dc92138143fb.png?imageView2/0/w/800",
        "title": "腾讯开源进入“深水区”，加码开源生态建设",
        "description": "11月7日，腾讯Techo开发者大会开源技术分论坛上，腾讯技术委员会对外开源管理办公室执行总监许勇首次披露，腾讯开源目前已进入“深水区”，改变过去“自下而上”的开源模式，向“自下而上”与“自上而下”相结合的协同式开发演进。",
        "link": "https://www.infoq.cn/article/iB5UVAp7CaMsxrmYBUoG",
        "tip": ""
      },
      {
        "排序": "7",
        "图片": "https://constatic.geekbang.org/infoq/5dcba29d2f4dc.png?imageView2/0/w/800",
        "title": "腾讯云林晓斌：腾讯云数据库运维进入智能时代",
        "description": "11月6日， 2019Techo开发者大会在北京正式召开，在数据库内核优化与最佳实践分论坛上，来自业内的多位专家交流探讨了数据库未来的发展趋势。",
        "link": "https://www.infoq.cn/article/KpTzz7JUqtXZbb6YbFmx",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "https://constatic.geekbang.org/infoq/5dcba29d6fadb.png?imageView2/0/w/800",
        "title": "腾讯云王龙：AI规模化落地进入“深水区”，需要跨过两道门槛",
        "description": "腾讯云副总裁王龙表示，AI规模化落地已经进入“深水区”。对于AI相关的开发者来说，能否克服构建AI模型和应用AI能力的两大挑战，是AI能否规模化落地的关键。",
        "link": "https://www.infoq.cn/article/MI1h07jxSA0iFiD4l771",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "https://constatic.geekbang.org/infoq/5dcba29e46766.png?imageView2/0/w/800",
        "title": "腾讯 5G 车路协同开源平台聚合产业势能，做智慧出行产业连接器",
        "description": "腾讯未来网络实验室专家俞一帆为与会者分享了腾讯建设5G车路协同开源平台的实践与进展。俞一帆表示，腾讯5G车路协同平台，是为了凝聚行业各方能力，广泛触达C端用户，形成数据闭环，推动智慧出行产业加速进化。 ",
        "link": "https://www.infoq.cn/article/IyyXEfr6iAjs4RpjNSNG",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "https://constatic.geekbang.org/infoq/5dcba29e0d245.png?imageView2/0/w/800",
        "title": "腾讯张云飞：4G解决人的通信，5G解决物的通信，6G解决智能社会的通信",
        "description": "腾讯未来网络实验室主任张云飞也发表了关于5G、6G网络的主题演讲，表示“4G解决人的通信，5G解决物的通信，6G则解决智能社会的通信”。",
        "link": "https://www.infoq.cn/article/N3YbrM5h5Oz7N9ODtP1f",
        "tip": ""
      }
    ]
  },
  "精彩瞬间": {
    "是否显示": true,
    "title": {
      "h1": "精彩瞬间",
      "h2": ""
    },
    "图片链接": [
      "https://constatic.geekbang.org/infoq/5dc8e79ae6d9f.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e79b3f6dc.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e79b72f88.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e7c042160.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e7c011df6.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e7c07342c.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e7f03e45e.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e7f06d037.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e7f0c59dd.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e806f2d2b.png?imageView2/0/w/800",
      "https://constatic.geekbang.org/infoq/5dc8e80731057.png?imageView2/0/w/800"
    ],
    "more": "",
    "link": ""
  },
  "视频回放": {
    "是否显示": false,
    "title": {
      "h1": "视频直击",
      "h2": "Video"
    },
    "list": [
      {
        "图片": "https://static.geekbang.org/infoq/5bab4bc2d6a9c.png?imageView2/0/w/800",
        "title": "峰会——华为云，使能商业创新，走向智能未来 ",
        "link": "http://www.bizconfstreaming.cn/hcc2017/huawei?language=cn&email=bGl5aTMyQGh1YXdlaS5jb20="
      },
      {
        "图片": "https://static.geekbang.org/infoq/5bab4c2789a3f.png?imageView2/0/w/800",
        "title": "T-Systems助力公有云发展",
        "link": "https://www.huawei.com/cn/press-events/events/huaweiconnect2017/voices/17092001"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5bab4c61d1a65.png?imageView2/0/w/800",
        "title": "HUAWEI CONNECT2017  大会首日花絮",
        "link": "https://www.huawei.com/cn/press-events/events/huaweiconnect2017/voices/Day-One-Highlights"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde209a51ba.png?imageView2/0/w/800",
        "title": "2017云+未来峰会圆桌对话：向未来发问",
        "link": "http://daxue.qq.com/content/content/id/3470"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde20a44bc3.png?imageView2/0/w/800",
        "title": "贾佳亚：视觉AI技术以及社会价值",
        "intro": "",
        "link": "http://daxue.qq.com/content/content/id/3465"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde209e7fb2.png?imageView2/0/w/800",
        "title": "顺丰CTO田民：科技改变物流，物流改变生活",
        "intro": "",
        "link": "http://daxue.qq.com/content/content/id/3467"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde209e7fb2.png?imageView2/0/w/800",
        "title": "顺丰CTO田民：科技改变物流，物流改变生活",
        "intro": "",
        "link": "http://daxue.qq.com/content/content/id/3467"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde209e7fb2.png?imageView2/0/w/800",
        "title": "顺丰CTO田民：科技改变物流，物流改变生活",
        "intro": "",
        "link": "http://daxue.qq.com/content/content/id/3467"
      },
      {
        "图片": "",
        "title": "",
        "link": ""
      },
      {
        "图片": "",
        "title": "",
        "link": ""
      },
      {
        "图片": "",
        "title": "",
        "link": ""
      }
    ]
  },
  "加入群组": {
    "是否显示": true,
    "title1": "关注 腾讯云 官方公众号",
    "title2": "第一时间了解更多资讯",
    "text": "",
    "二维码": "https://constatic.geekbang.org/infoq/5dc8e8700bc9e.png?imageView2/0/w/800"
  }
}